function Guima() {
  return (
    <div
      id="guima"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1>
          "Os outros eu conheci por ocioso acaso. A ti vim encontrar porque era
          preciso"
        </h1>
        <h4>— João Guimarães Rosa</h4>
      </div>
    </div>
  );
}

export default Guima;
